<template>
    <v-btn-toggle v-model="query['margin.type']" borderless active-class="white elevation-4" color="primary" class="grey lighten-4" style="width:100%;border-radius:8px!important" @change="emit">
        <template v-for="{ text, value } in types">
            <v-btn :width="`calc(100% / ${types.length})`" style="border-radius: 8px!important;white-space:pre-line" v-bind="{ value }" :key="text">
                <span style="line-height:1!important">
                    {{ text }}
                </span>
            </v-btn>
        </template>
    </v-btn-toggle>
</template>

<script>
import { mapState } from "vuex";
const initQuery = (form = {}) => ({
    ...(form || {}),
    ["margin.type"]: form?.["margin.type"] || null,
});

export default {
    data: () => ({
        query: initQuery(),
    }),
    computed: {
        ...mapState({ hasMarginCash: (store) => store?.user?.hasMarginCash }),
        types() {
            return [
                { text: "전체", value: null },
                { text: "선물하기\n입금수수료", value: "선물하기 입금수수료 마진" },
                { text: "모두의애드\n전환수수료", value: "모두의애드 전환수수료 마진" },
            ];
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (!query["margin.type"]) delete query["margin.type"];

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.v-btn-toggle > .v-btn.v-btn--active {
    opacity: 1;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn--active.white {
    border-width: 1px;
    border-style: solid;
    border-color: var(--v-primary-base) !important;
}
</style>
